import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { IdiomasDTO } from 'src/app/core/models/persona/interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlPersona;

@Injectable()
export class IdiomasService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) {}

  getIdiomasService(): Observable<BodyListResponse<IdiomasDTO>> {
    return this.http.get<BodyListResponse<IdiomasDTO>>(API_URL + '/api/v1/idiomas/todos');
  }

  guardarIdiomasService(idiomasDTO: IdiomasDTO): Observable<IdiomasDTO> {
    return this.http.post<IdiomasDTO>(API_URL + '/api/v1/idiomas', idiomasDTO);
  }

  getIdiomasPorCodigoIdiomasService(codigoIdiomas: string): Observable<BodyResponse<IdiomasDTO>> {
    return this.http.get<BodyResponse<IdiomasDTO>>(API_URL + '/api/v1/idiomas/' + codigoIdiomas);
  }
}
